import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import { FormattedMessage } from '../../util/reactIntl';
import {Grid} from '@material-ui/core'

// IMG
// import ImgLeft from '../../assets/about/left.jpg'
import ImgLeaf1 from '../../assets/about/leaf_1.png'
import ImgLeaf2 from '../../assets/about/leaf_2.png'
import ImgLeaf3 from '../../assets/about/transparent-flower.png'
import ImgPotager from '../../assets/about/garden.jpg'
import ImgPotager2 from '../../assets/about/garden2.jpg'
import ImgPinkLeaf2 from '../../assets/about/feuille_rose2.png'
import ImgPinkLeaf from '../../assets/about/feuille_rose.png'





import { ReactComponent as IconBirthday } from '../../assets/about/anniversaire.svg'
import { ReactComponent as IconWedding } from '../../assets/about/mariage.svg'
import { ReactComponent as IconRest } from '../../assets/about/location_garden.svg'
import { ReactComponent as IconBaby } from '../../assets/about/bebe.svg'




import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer
} from '../../components';

import css from './AboutPage.module.css';

const AboutPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  // prettier-ignore
  return (
    <StaticPage
      title="A propos"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: 'A propos de jardin privés',
        name: 'A propos page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain  className={css.mainWrapper}>
            <div className={css.headerWrapper}>
              <h1 className={css.headerTitle}><FormattedMessage id="AboutPage.headerTitle"/></h1>
            </div>

          <div className={css.content}>

            <h1 className={css.contentTitle}><FormattedMessage id="AboutPage.contentTitle1"/></h1>
            <h2 className={css.contentIntro}><FormattedMessage id="AboutPage.contentIntro"/></h2>
          <Grid container spacing={5} justify="center">
            <Grid item xs={6} sm={6} md={3}>
              <div className={css.stepWrapper}>
                  <IconRest style={{height: 40}}/>
              </div>
              <p className={css.stepTitle}>
                <FormattedMessage id="AboutPage.step1"/>
              </p>
              <p className={css.caption}><FormattedMessage id="AboutPage.step1_1"/></p>
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <div className={css.stepWrapper}>
                  <IconBirthday style={{height: 40}} />
              </div>
              <p className={css.stepTitle}>
                <FormattedMessage id="AboutPage.step2"/>
              </p>
              <p className={css.caption}><FormattedMessage id="AboutPage.step2_1"/></p>
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <div className={css.stepWrapper}>
                  <IconWedding style={{height: 40}} />
              </div>
              <p className={css.stepTitle}>
                  <FormattedMessage id="AboutPage.step3"/>
                </p>
                <p className={css.caption}><FormattedMessage id="AboutPage.step3_1"/></p>
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <div className={css.stepWrapper}>
                  <IconBaby style={{height: 40}}/>
              </div>
              <p className={css.stepTitle}>
                <FormattedMessage id="AboutPage.step4"/>
              </p>
              <p className={css.caption}><FormattedMessage id="AboutPage.step4_1"/></p>
            </Grid>
          </Grid>
          <div className={css.block1Title}>
            <img src={ImgLeaf1} height="80" />
            <h1 ><FormattedMessage id="AboutPage.contentTitle2"/></h1>
          </div>
          <div className={css.block1}>
            <h2>
              <FormattedMessage id="AboutPage.contentText2"/>
            </h2>
          </div>

          <div className={css.block2Title} style={{marginBottom: 30}}>
            <h1><FormattedMessage id="AboutPage.contentTitle3"/></h1>
          </div>

          <Grid container spacing={0}>
            <Grid item xs={12} sm={12} md={6} style={{marginBottom: 50}}>
                <img src={ImgPotager} alt="left" className={css.img} />
              </Grid>
            <Grid item xs={12} sm={12} md={6}>
            <div className={css.block1Content}>
                  <p><FormattedMessage id="AboutPage.contentText3"/></p>
                  <span style={{
                    borderLeft:" 1px solid #b7b7b7",
                    height: "30px"
                  }}></span>
                  <p><FormattedMessage id="AboutPage.contentText3_1"/></p>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <div className={css.block1Content}>
                  <img className={css.pinkLeaf} src={ImgPinkLeaf2} alt="pink-left" height="30" />
                  <p><FormattedMessage id="AboutPage.contentTitle4"/></p>
                  <p><FormattedMessage id="AboutPage.contentText4"/></p>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <div style={{ textAlign: "center"}} >
                <img src={ImgPotager2} alt="left"  style={{maxHeight: "80%", maxWidth: "80%", textAlign: "center"}} />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={0}>
            <Grid item xs={12} sm={12} md={6}>
              <div className={css.imgBlock2}>
                <img src={ImgLeaf3} alt="right" className={css.img} />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} className={css.block2Content}>
                <h2 style={{margin: 0}}><FormattedMessage id="AboutPage.contentTitle5"/></h2>
                <p><FormattedMessage id="AboutPage.contentText5"/></p>
                <p><FormattedMessage id="AboutPage.contentText5_1"/></p>
            </Grid>
          </Grid>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default AboutPage;
